import * as Yup from 'yup';

export const schema = Yup.object().shape({});

const SCHEMA1 = Yup.object().shape({
  // UploadToServerTitle: Yup.string().required('وارد کردن عنوان الزامی است'),
});

const SCHEMA2 = Yup.object().shape({
  UploadedFileNameWithLink: Yup.string()
    .required('وارد کردن لینک الزامی است')
    // .matches(/(https?:\/\/.*\.(mp4)).*$/, 'لینک باید به یک فایل mp4 ختم شود'),
});

export { SCHEMA1, SCHEMA2 };
